import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { postApi, baseURL } from "../components/Utility";
import config from "../config";
import { message } from "antd";
import {
    action,
    makeObservable,
    observable,

} from 'mobx';


class AiAlarmReportStore {
    alarmData = []
    total = 0
    loading = false
    rootStore
    alarmlist = []

    constructor(rootStore) {
        makeObservable(this, {
            alarmData: observable,
            total: observable,
            loading: observable,
            alarmlist: observable,
            loadData: action,
            getAlarms: action

        });
        this.rootStore = rootStore;

    }

    async loadData({ offset, limit, companyId, vehicleId, alarmId, fromDate, toDate }) {
        console.log("Ai alarm Report")
        var postData = { "companyId": companyId, "vehicleId": vehicleId, "alarmId": alarmId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": 1 }
        var response;
        const base64Input = await base64_encode(JSON.stringify(postData));
         if (config.pythonReport === 1) {
             response = await postApi.getClient('report').post("miscellaneous_report/ai_alarmreport", postData);
        }else{
            response = await postApi.getClient().post("index.php?c=vehicle&a=AI_AlarmReport", "postData=" + base64Input);

        }
        console.log("alarm ", response?.data?.data)
        //  data is not there 
        this.alarmData = response?.data?.data?.alarmData;
        console.log(this.alarmData)
        this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
    }
    async getAlarms() {
        var postData = {
        };
        // const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient("NodeCoreUrl")
            .get("/aiDashboard/getAiAlarms");
            // .post("index.php?c=vehicle&a=getAlarmType", "postData=" + base64Input);

        // let allalarms = [{ alarmId: 0, alarmName: "ALL" }];
        // allalarms = [response?.data?.data];
        this.alarmlist = response?.data?.data;
        return response?.data;
    }

    async getDevices(data) {
        var postData = data;
        // const base64Input = await base64_encode(JSON.stringify(postData));
        // var response = await postApi
        //     .getClient()
        //     .post(
        //         "index.php?c=videoStreaming&a=getdevices2",
        //         "postData=" + base64Input
        //     );
         var response = await postApi
            .getClient("NodeCoreUrl")
            .get("VideoMonitoring/getDevicesData", {
                params: postData,
            });
        return response.data.data?.vehicles;
    }

    async getAIdata(data) {
        var postData = data;
        
            const base64Input = await base64_encode(JSON.stringify(postData));
        //    var response = await postApi.getClient().post("index.php?c=vehicle&a=getAIData", "postData=" + base64Input);
           var response = await postApi.getClient("NodeCoreUrl")
           .post("/aiDashboard/getAidata", postData);

        return response;
    }

    async exportExcel(getData) {

        if (config.pythonReport === 1) {
            try {
                var response = await postApi.getClient("report").post("miscellaneous_report/ai_alarmreport/download/excel", getData, {
                    responseType: "blob",
                });

                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "AI Alarm Report.xlsx";

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                message.error("Failed to download the report. Please try again.")
            }

        } else {
            console.log("getData", getData);
            window.location.href =
                baseURL +
                "index.php?c=vehicle&a=exportAI_ReportExcel&cid=" +
                getData.companyId +
                "&vehicleId=" +
                getData.vehicleId +
                "&alarmId=" +
                getData.alarmId +
                "&fD=" +
                getData.fromDate +
                "&tD=" +
                getData.toDate +
                "&colList=" +
                getData.colList;
        }


    }

    async exportpdf(getData) {
        if(config.pythonReport === 1){    
      try {

        var response = await postApi.getClient("report").post("miscellaneous_report/ai_alarmreport/download/pdf", getData, {
            responseType: "blob",
        });
    
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "AI Alarm Report.pdf";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    } else {
            window.location.href =
                baseURL +
                "index.php?c=vehicle&a=exportAI_ReportPdf&cid=" +
                getData.companyId +
                "&vehicleId=" +
                getData.vehicleId +
                "&alarmId=" +
                getData.alarmId +
                "&fD=" +
                getData.fromDate +
                "&tD=" +
                getData.toDate +
                "&colList=" +
                getData.colList;
        }

    }

}

export default AiAlarmReportStore;
